<template>
  <div class="report">
    <BackCurrent v-if="appVersion === 'dd'" title="活动报告" />
    <ul class="report-list">
      <li class="report-item" v-for="item in list" :key="item.eventInfoId" @click="handleClick(item.eventInfoId)">
        <h4 class="title">{{ item.eventName }}</h4>
        <div class="time">{{ item.eventStartTime | format_Date_c }}</div>
        <span class="no-start" v-if="item.noStart">未开始</span>
      </li>
    </ul>
  </div>
</template>

<script>
import BackCurrent from '@/components/back-current'
import {statSimpleDataByType} from '@/api/dd'
export default {
  name: 'report',
  components: {
    BackCurrent
  },
  data() {
    return {
      startTime: '',
      endTime: '',
      pageNo: 1,
      pageSize: 20,
      list: [],
      total: null
    }
  },
  methods: {
    getData() {
      statSimpleDataByType(this.endTime, this.pageNo, this.pageSize, this.startTime).then(res => {
        if (res.code === 0 && res.success) {
          this.list = [...this.list, ...res.data]
          this.list = this.list.map(item => {
            const time = new Date().getTime()
            if (time < item.eventStartTime) {
              item.noStart = true
            } else {
              item.noStart = false
            }
            return item
          })
          this.total = Math.ceil(Number(res.totalDatas) / this.pageSize)
          this.pageNo += 1
        }
      })
    },
    handleClick(id) {
      window.open(`${this.statReportUrl}${id}`, '_self')
    },
    getScroll() {
      return {
        left: window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0,
        top: window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
      }
    },
    handleScroll() {
      const body = document.documentElement || document.body
      const scrollTop = this.getScroll().top
      const scrollHeight = body.scrollHeight
      const clientHeight = body.clientHeight
      if (scrollTop + clientHeight >= scrollHeight - 30) {
        if (this.pageNo > this.total) {
          return
        }
        this.getData()
      }
    }
  },
  mounted() {
    this.getData()
    document.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    document.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style lang="scss" scoped>
.report {
  width: 100%;
  min-height: 100%;
  background: #f7f7f7;
  .report-list {
    margin-top: 20px;
    width: 100%;
    padding: 0 15px 20px;
    box-sizing: border-box;
    .report-item {
      position: relative;
      margin-bottom: 14px;
      width: 100%;
      padding: 20px;
      border-radius: 8px;
      box-sizing: border-box;
      background: #fff;
      box-shadow: 0px 5px 16px 0px rgba(0, 0, 0, 0.04);
      .title {
        font-size: 15px;
        font-weight: 600;
        color: #303133;
      }
      .time {
        margin-top: 18px;
        font-size: 13px;
        color: #909399;
      }
      .no-start {
        position: absolute;
        right: 0;
        top: 0;
        width: 56px;
        height: 22px;
        padding: 3px 10px;
        box-sizing: border-box;
        background-color: #fda423;
        border-top-right-radius: 8px;
        border-bottom-left-radius: 8px;
        font-size: 12px;
        color: #fff;
      }
    }
  }
}
</style>
